export const PATH = {
    ADDRESS_DETAILS: '/my-quote/address-details',
    ADD_NEW_QUOTE: '/my-quote/add-new-quote',
    ADD_QUOTE: '/my-quote/add-quote',
    CREATE_QUOTE: '/my-quote/create-quote',
    DIMENSIONS: '/my-quote/dimensions',
    QUOTE_DETAIL: '/my-quote',
    REQ_MY_QUOTE: '/quotes/request',
    FEEDBACK_LIST: '/feedback',
    TARGET_SET: '/set-target',
    CUSTOMER_DETAILS: `/customers`,
    CUSTOMER_GROUP_DETAILS: `/customers/customers-group`,
    REQ_ADDRESS_DETAILS: '/quotes/request/address-details',
    REQ_DIMENSIONS: '/quotes/request/dimensions',
    TEAM_MANAGEMENT: '/team-management',
    LOAD_INSURANCE: '/load-insurance',
    CLAIMS_AND_DISPUTES_DETAILS: `/claims-and-disputes`,
    CLAIM_DETAILS: `/claims-and-disputes/claim-details`,
    DISPUTE_DETAILS: `/claims-and-disputes/dispute-details`,
    CUSTOMER_ONBOARDING: `/customer-onboarding`,
    SUBMISSION: `/customer-onboarding/submission`,
    THANK_YOU: `/customer-onboarding/thank-you`,
    COMMISSION_REPORT: `/sales/commission-report`,
    ORDER_DETAILS: `/order-details`,
    ORDER_VIEW: `/orders`,
    SETUP_ACCOUNT: '/setup-account',
    RADAR: '/radar',
    TRACK: '/track',
    MY_QUOTE: '/my-quote',
};
